export const diseaseTableHeaders = [
  {
    title: "Disease",
    class: "tw-text-left",
    key: "name",
  },
  {
    title: "Association",
    class: "tw-text-center",
    key: "association",
  },
  {
    title: "Pharmacodynamic",
    class: "tw-text-center",
    key: "pharmacodynamic",
  },
  {
    title: "Pharmacokinetic",
    class: "tw-text-center",
    key: "pharmacokinetic",
  },
];
